import { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';

const ICONOS = [
  '🔧','🔩','⚙️','🛠️','🔌','⚡','🔋','🚗','🏍️','🚛','🚙','🚕',
  '🔍','🖥️','📱','📋','✅','❌','⭐','🏆','💡','🎯','📦','🚚',
  '🤝','💬','📞','✉️','📍','🗺️','🏪','🏭','👨‍🔧','👩‍🔧','🧰','🪛',
  '🔦','💪','🛡️','✔️','🎁','💰','🔑','🏅','📢','🌟','💎','🚀'
];

export default function Servicios() {
  const [servicios, setServicios] = useState([]);
  const [modal, setModal] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({nombre:'', descripcion:'', icono:'🔧', orden:0, activo:true});
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const cargar = () => axios.get(`${API}/servicios/`).then(r => setServicios(r.data));
  useEffect(() => { cargar(); }, []);

  const abrir = (s?: any) => {
    if (s) { setEditando(s); setForm({nombre:s.nombre, descripcion:s.descripcion||'', icono:s.icono||'🔧', orden:s.orden||0, activo:s.activo}); }
    else { setEditando(null); setForm({nombre:'', descripcion:'', icono:'🔧', orden:0, activo:true}); }
    setShowPicker(false);
    setModal(true);
  };

  const guardar = async (e: any) => {
    e.preventDefault();
    if (editando) await axios.put(`${API}/servicios/${editando.id}`, form, { headers });
    else await axios.post(`${API}/servicios/`, form, { headers });
    setModal(false);
    cargar();
  };

  const eliminar = async (id: number) => {
    if (!window.confirm('¿Eliminar este servicio?')) return;
    await axios.delete(`${API}/servicios/${id}`, { headers });
    cargar();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="font-bold text-2xl text-azul">Servicios</h1>
          <p className="text-gray-500 text-sm">{servicios.length} servicios registrados</p>
        </div>
        <button onClick={() => abrir()} className="bg-azul text-white px-5 py-2.5 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors">
          + Agregar servicio
        </button>
      </div>

      <div className="space-y-3">
        {(servicios as any[]).map((s: any) => (
          <div key={s.id} className="bg-white rounded-2xl border border-gray-100 p-5 flex items-center gap-4 hover:border-azul transition-colors">
            <div className="w-12 h-12 bg-azul/10 rounded-xl flex items-center justify-center text-2xl flex-shrink-0">{s.icono || '🔧'}</div>
            <div className="flex-1">
              <div className="font-bold text-azul">{s.nombre}</div>
              <div className="text-gray-400 text-sm mt-0.5">{s.descripcion}</div>
            </div>
            <span className={`text-xs px-2 py-1 rounded-full font-bold ${s.activo ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
              {s.activo ? 'Activo' : 'Inactivo'}
            </span>
            <div className="flex gap-2">
              <button onClick={() => abrir(s)} className="text-azul hover:bg-azul/10 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors">Editar</button>
              <button onClick={() => eliminar(s.id)} className="text-rojo hover:bg-rojo/10 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors">Eliminar</button>
            </div>
          </div>
        ))}
        {servicios.length === 0 && (
          <div className="text-center py-16 text-gray-400 bg-white rounded-2xl border border-gray-100">
            <div className="text-4xl mb-3">🔧</div>
            <p>No hay servicios registrados</p>
          </div>
        )}
      </div>

      {modal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
            <div className="p-6 border-b border-gray-100">
              <h2 className="font-bold text-lg text-azul">{editando ? 'Editar servicio' : 'Nuevo servicio'}</h2>
            </div>
            <form onSubmit={guardar} className="p-6 space-y-4">
              <div className="grid grid-cols-4 gap-3">
                <div>
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">ÍCONO</label>
                  <button type="button" onClick={() => setShowPicker(!showPicker)}
                    className="w-full border-2 border-gray-200 rounded-lg py-2 text-3xl text-center hover:border-azul transition-colors">
                    {form.icono}
                  </button>
                </div>
                <div className="col-span-3">
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">NOMBRE</label>
                  <input required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
                </div>
              </div>

              {/* Picker de íconos */}
              {showPicker && (
                <div className="border border-gray-200 rounded-xl p-3 bg-gray-50">
                  <div className="text-xs font-bold text-gray-500 tracking-wider mb-2">SELECCIONAR ÍCONO</div>
                  <div className="grid grid-cols-8 gap-1">
                    {ICONOS.map(ico => (
                      <button key={ico} type="button" onClick={() => { setForm({...form, icono: ico}); setShowPicker(false); }}
                        className={`text-2xl p-1.5 rounded-lg hover:bg-azul/10 transition-colors ${form.icono === ico ? 'bg-azul/20 ring-2 ring-azul' : ''}`}>
                        {ico}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">DESCRIPCIÓN</label>
                <textarea value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})}
                  rows={3} className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul resize-none"/>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex-1">
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">ORDEN</label>
                  <input type="number" value={form.orden} onChange={e => setForm({...form, orden: parseInt(e.target.value)})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
                </div>
                <label className="flex items-center gap-2 cursor-pointer mt-5">
                  <input type="checkbox" checked={form.activo} onChange={e => setForm({...form, activo: e.target.checked})} className="w-4 h-4 accent-azul"/>
                  <span className="text-sm text-gray-600 font-medium">Activo</span>
                </label>
              </div>
              <div className="flex gap-3 pt-2">
                <button type="submit" className="flex-1 bg-azul text-white py-2.5 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors">
                  {editando ? 'Guardar cambios' : 'Crear servicio'}
                </button>
                <button type="button" onClick={() => setModal(false)} className="px-6 border border-gray-200 rounded-xl text-gray-500 text-sm">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
